import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { addCandidate, getJobrole } from "../http/api";
import { addCandidate, updateCandidate, getCandidateByAadharAndProject, getJobrole, uploadFile } from "../http/api";

import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import Loading from "../loading/loading";
import "../common/style.css";
// import { uploadFile } from "../http/api";
import imageCompression from "browser-image-compression";
import {
  CAST_CATEGORIES,
  RELIGIONS,
  EDUCATION_LEVELS,
  GENDERS,
  MARITAL_STATUSES,
  PRETRAINING_STATUS,
  DISABILITY_STATUS,
  STATE
} from "../../utils/formOptions";
import { toast } from "react-toastify";
import { downloadFile } from "../http/api";





export default function AddCandidate() {
  // const { projectId } = useParams();
  const navigate = useNavigate();

  const [isSidebarOpen, setIsSidebarOpen] = useState(
    localStorage.getItem("sb|sidebar-toggle") === "true"
  );
  const [loading, setLoading] = useState(false);
  const [jobRoles, setJobRoles] = useState([]);
  const [errors, setErrors] = useState({});
  const { projectId, aadharNumber } = useParams();
  const isEditMode = Boolean(aadharNumber);

  // 📥 Local file download for uploaded formData
  const handleLocalDownload = (file) => {
    if (!file) return;
    const fileURL = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(fileURL);
  };

  const handleFileUploadInstant = async (e, storedKey, prefix) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const compressed = await compressImage(file);

      const now = new Date();
      const yyyyMMdd = now.toISOString().slice(0, 10).replace(/-/g, "");
      const HHmmss = now.toTimeString().slice(0, 8).replace(/:/g, "");
      const cleanName = compressed.name.replace(/\s+/g, "_");

      const keyName = `${formData.aadharNumber}_${prefix}_${yyyyMMdd}_${HHmmss}_${cleanName}`;

      const fd = new FormData();
      fd.append("file", compressed);
      fd.append("keyName", keyName);

      const res = await uploadFile(fd);

      if (res.status === 200 || res.status === 202) {
        toast.success("Uploaded successfully");

        setFormData(prev => ({
          ...prev,
          [storedKey]: keyName
        }));
      }
    } catch (err) {
      toast.error("Upload failed");
    }
  };


  const handleServerDownload = async (keyName, originalName = "download") => {
    try {
      const res = await downloadFile(keyName);
      const blob = new Blob([res.data], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = originalName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("❌ File download failed:", err);
      toast.error("Failed to download file", { autoClose: 4000 });
    }
  };

  useEffect(() => {
    if (isEditMode) {
      setLoading(true);
      getCandidateByAadharAndProject(aadharNumber, projectId)
        .then(res => {
          if (res.status === 200) {
            setFormData(res.data);
          } else {
            alert("Candidate not found");
            navigate(`/manageCandidates/${projectId}`);
          }
        })
        .catch(err => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [isEditMode, aadharNumber, projectId, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      // Upload each file first

      const response = isEditMode
        ? await updateCandidate(formData)
        : await addCandidate(formData);

      if (response.status === 200 || response.status === 201) {
        toast.success(isEditMode ? "Candidate updated" : "Candidate added");
        navigate(`/manageCandidates/${projectId}`);
      } else {
        toast.error("Failed to save candidate");
      }
    } catch (err) {
      console.error("Error saving candidate:", err);
      alert("Something went wrong while saving the candidate");
    } finally {
      setLoading(false);
    }
  };




  const [formData, setFormData] = useState({
    candidateName: "",
    aadharNumber: "",
    gender: "",
    dateOfBirth: "",
    email: "",
    mobile: "",
    maritalStatus: "",
    fatherName: "",
    motherName: "",
    guardianName: "",
    castCategory: "",
    religion: "",
    preTrainingStatus: "",
    disability: "",
    education: "",
    address: "",
    state: "",
    pinCode: "",
    alternativeMobile: "",
    yearofExperience: 0,
    bankAccountNumber: "",
    bankName: "",
    ifsc: "",
    bankAccountName: "",
    candidatePhoto: "",
    frontAadharPhoto: "",
    backAadharPhoto: "",
    educationPhoto: "",
    bankPhoto: "",
    castPhoto: "",
    submittedBy: "",
    projectTrans: [
      { projectId: parseInt(projectId), jobrole: "" }
    ],
  });

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    localStorage.setItem("sb|sidebar-toggle", !isSidebarOpen);
  };

  useEffect(() => {
    // Fetch job roles for dropdown
    getJobrole()
      .then((response) => {
        if (response.status === 200) {
          setJobRoles(response.data || []);
        }
      })
      .catch((err) => console.error("Error fetching job roles:", err));
  }, []);

  // const validateForm = () => {
  //   const newErrors = {};
  //   let missingDocs = [];
  //   let missingFields = [];

  //   // Required field validation

  //   if (!formData.frontAadharPhoto) {
  //     newErrors.aadharFront = "Aadhaar Front is required";
  //   }
  //   if (!formData.aadharBack && !formData.backAadharPhoto) {
  //     newErrors.aadharBack = "Aadhaar Back is required";
  //   }
  //   if (!formData.candidateName.trim()) {
  //     newErrors.candidateName = "Candidate name is required";
  //   } else if (formData.candidateName.length > 100) {
  //     newErrors.candidateName = "Candidate name cannot exceed 100 characters";
  //   }

  //   if (!formData.aadharNumber.trim()) {
  //     newErrors.aadharNumber = "Aadhar number is required";
  //   } else if (!/^\d{12}$/.test(formData.aadharNumber)) {
  //     newErrors.aadharNumber = "Aadhar number must be exactly 12 digits";
  //   }

  //   if (!formData.gender) {
  //     newErrors.gender = "Gender is required";
  //   }

  //   if (!formData.dateOfBirth) {
  //     newErrors.dateOfBirth = "Date of birth is required";
  //   } else if (new Date(formData.dateOfBirth) >= new Date()) {
  //     newErrors.dateOfBirth = "Date of birth must be in the past";
  //   }

  //   if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
  //     newErrors.email = "Please enter a valid email";
  //   }

  //   if (!formData.mobile.trim()) {
  //     newErrors.mobile = "Mobile number is required";
  //   } else if (!/^\d{10}$/.test(formData.mobile)) {
  //     newErrors.mobile = "Mobile number must be exactly 10 digits";
  //   }

  //   if (!formData.maritalStatus) {
  //     newErrors.maritalStatus = "Marital status is required";
  //   }

  //   if (formData.fatherName && formData.fatherName.length > 100) {
  //     newErrors.fatherName = "Father's name cannot exceed 100 characters";
  //   }

  //   if (formData.motherName && formData.motherName.length > 100) {
  //     newErrors.motherName = "Mother's name cannot exceed 100 characters";
  //   }

  //   if (formData.guardianName && formData.guardianName.length > 100) {
  //     newErrors.guardianName = "Guardian's name cannot exceed 100 characters";
  //   }

  //   if (!formData.castCategory) {
  //     newErrors.castCategory = "Cast category is required";
  //   }

  //   if (!formData.religion) {
  //     newErrors.religion = "Religion is required";
  //   }

  //   if (!formData.preTrainingStatus) {
  //     newErrors.preTrainingStatus = "Pre-training status is required";
  //   }

  //   if (!formData.disability) {
  //     newErrors.disability = "Disability status is required";
  //   }

  //   if (!formData.education) {
  //     newErrors.education = "Education is required";
  //   }

  //   if (!formData.address.trim()) {
  //     newErrors.address = "Address is required";
  //   } else if (formData.address.length > 255) {
  //     newErrors.address = "Address cannot exceed 255 characters";
  //   }

  //   if (!formData.state.trim()) {
  //     newErrors.state = "State is required";
  //   }

  //   if (!formData.pinCode.trim()) {
  //     newErrors.pinCode = "Pincode is required";
  //   } else if (!/^\d{6}$/.test(formData.pinCode)) {
  //     newErrors.pinCode = "Pincode must be exactly 6 digits";
  //   }

  //   if (formData.alternativeMobile && !/^\d{10}$/.test(formData.alternativeMobile)) {
  //     newErrors.alternativeMobile = "Alternative mobile must be exactly 10 digits";
  //   }

  //   if (formData.yearofExperience < 0) {
  //     newErrors.yearofExperience = "Years of experience cannot be negative";
  //   }

  //   if (formData.submittedBy && formData.submittedBy.length > 200) {
  //     newErrors.submittedBy = "Submitted by cannot exceed 200 characters";
  //   }

  //   if (!formData.projectTrans[0].jobrole) {
  //     newErrors.jobrole = "Job role is required";
  //   }

  //   const missingFields = Object.values(newErrors).join(", ");
  //   toast.error(`Please upload: ${missingFields}`, {
  //     autoClose: 4000, // ⏱ 4 seconds
  //     position: "top-right",
  //     closeOnClick: true,
  //   });


  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const validateForm = () => {
  const newErrors = {};
  let missingDocs = [];
  let missingFields = [];

  // -----------------------------
  // 📌 Check Required Documents
  // -----------------------------
  // if (!formData.candidatePhoto) {
  //   newErrors.candidatePhoto = "Candidate photo is required";
  //   missingDocs.push("Candidate Photo");
  // }

  if (!formData.frontAadharPhoto) {
    newErrors.aadharFront = "Aadhaar front photo is required";
    missingDocs.push("Aadhaar Front");
  }

  if (!formData.backAadharPhoto) {
    newErrors.aadharBack = "Aadhaar back photo is required";
    missingDocs.push("Aadhaar Back");
  }

  // if (!formData.educationPhoto) {
  //   newErrors.educationCert = "Education certificate is required";
  //   missingDocs.push("Education Certificate");
  // }

  // if (!formData.bankPhoto) {
  //   newErrors.cancelledCheque = "Cancelled cheque is required";
  //   missingDocs.push("Cancelled Cheque");
  // }

  // if (formData.castCategory !== "General" && !formData.castPhoto) {
  //   newErrors.castCert = "Caste certificate is required";
  //   missingDocs.push("Caste Certificate");
  // }

  // -----------------------------
  // 📌 Check Required Input Fields
  // -----------------------------
  const requiredTextFields = {
    candidateName: "Candidate Name",
    aadharNumber: "Aadhar Number",
    gender: "Gender",
    dateOfBirth: "Date of Birth",
    mobile: "Mobile Number",
    maritalStatus: "Marital Status",
    castCategory: "Cast Category",
    religion: "Religion",
    preTrainingStatus: "Pre-training Status",
    disability: "Disability",
    education: "Education",
    address: "Address",
    state: "State",
    pinCode: "Pincode",
  };

  Object.entries(requiredTextFields).forEach(([key, label]) => {
    if (!formData[key] || formData[key].toString().trim() === "") {
      newErrors[key] = `${label} is required`;
      missingFields.push(label);
    }
  });

  if (!formData.projectTrans[0].jobrole) {
    newErrors.jobrole = "Job role is required";
    missingFields.push("Job Role");
  }

  // -----------------------------
  // ❗ Toast Warning
  // -----------------------------
  if (missingFields.length > 0 || missingDocs.length > 0) {
    const msg = `
      ${missingFields.length ? "Missing Fields:\n- " + missingFields.join("\n- ") : ""}
      ${missingDocs.length ? "\nMissing Documents:\n- " + missingDocs.join("\n- ") : ""}
    `;

    toast.error(msg, { autoClose: 5000, position: "top-right" });
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const handleJobRoleChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      projectTrans: [{ ...prev.projectTrans[0], jobrole: value }],
    }));

    if (errors.jobrole) {
      setErrors(prev => ({ ...prev, jobrole: "" }));
    }
  };


  // ✅ Compress image before uploading
  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 0.5, // Target max file size (0.5MB)
      maxWidthOrHeight: 1024, // Resize images to max 1024px width or height
      useWebWorker: true,
    };
    try {
      const compressedFile = await imageCompression(file, options);
      console.log(
        `Compressed from ${(file.size / 1024 / 1024).toFixed(2)}MB → ${(compressedFile.size / 1024 / 1024).toFixed(2)}MB`
      );
      return compressedFile;
    } catch (error) {
      console.error("Image compression error:", error);
      return file; // fallback: use original if compression fails
    }
  };


  return (
    <div className="AddCandidate">
      {loading && <Loading />}
      <div
        className={`sb-nav-fixed ${isSidebarOpen ? "sb-sidenav-toggled" : ""}`}
      >
        <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div id="layoutSidenav">
          <SideNave isSidebarOpen={isSidebarOpen} />
          <div id="layoutSidenav_content">
            <main>
              <div className="container-fluid px-4">
                <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
                  <h4>{isEditMode ? "Edit Candidate" : "Add New Candidate"}</h4>
                  <button
                    className="btn btn-secondary"
                    onClick={() => navigate(`/manageCandidates/${projectId}`)}
                  >
                    Back to Candidates
                  </button>
                </div>

                <div className="card">
                  <div className="card-header">
                    <i className="fas fa-user-plus me-1"></i>
                    Candidate Information
                  </div>
                  <div className="card-body">

                    {/* Document Upload Section */}
                    {/* Document Upload Section */}

                    <form onSubmit={handleSubmit} className="row g-3">
                      {/* Personal Information */}
                      <div className="col-12">
                        <h5 className="text-primary border-bottom pb-2 mb-3">Personal Information</h5>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Candidate Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="candidateName"
                          className={`form-control ${errors.candidateName ? 'is-invalid' : ''}`}
                          value={formData.candidateName}
                          onChange={handleChange}
                          placeholder="Enter full name"
                          maxLength="100"
                        />
                        {errors.candidateName && (
                          <div className="invalid-feedback">{errors.candidateName}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Aadhar Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="aadharNumber"
                          className={`form-control ${errors.aadharNumber ? 'is-invalid' : ''}`}
                          value={formData.aadharNumber}
                          onChange={handleChange}
                          placeholder="12 digit Aadhar number"
                          maxLength="12"
                          disabled={isEditMode} // ✅ Disable when editing
                          readOnly={isEditMode} // optional - extra safety
                          style={isEditMode ? { backgroundColor: "#f1f1f1", cursor: "not-allowed" } : {}}
                        />
                        {errors.aadharNumber && (
                          <div className="invalid-feedback">{errors.aadharNumber}</div>
                        )}
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          Gender <span className="text-danger">*</span>
                        </label>
                        <select
                          name="gender"
                          className={`form-select ${errors.gender ? 'is-invalid' : ''}`}
                          value={formData.gender}
                          onChange={handleChange}
                        >
                          <option value="">--Select Gender--</option>
                          {GENDERS.map((r) => (
                            <option key={r} value={r}>{r}</option>
                          ))}
                        </select>
                        {errors.gender && (
                          <div className="invalid-feedback">{errors.gender}</div>
                        )}
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          Date of Birth <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          name="dateOfBirth"
                          className={`form-control ${errors.dateOfBirth ? 'is-invalid' : ''}`}
                          value={formData.dateOfBirth}
                          onChange={handleChange}
                          max={new Date().toISOString().split('T')[0]}
                        />
                        {errors.dateOfBirth && (
                          <div className="invalid-feedback">{errors.dateOfBirth}</div>
                        )}
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          Marital Status <span className="text-danger">*</span>
                        </label>
                        <select
                          name="maritalStatus"
                          className={`form-select ${errors.maritalStatus ? 'is-invalid' : ''}`}
                          value={formData.maritalStatus}
                          onChange={handleChange}
                        >
                          <option value="">--Select Status--</option>
                          {MARITAL_STATUSES.map((r) => (
                            <option key={r} value={r}>{r}</option>
                          ))}
                        </select>
                        {errors.maritalStatus && (
                          <div className="invalid-feedback">{errors.maritalStatus}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Email
                        </label>
                        <input
                          type="email"
                          name="email"
                          className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="example@email.com"
                        />
                        {errors.email && (
                          <div className="invalid-feedback">{errors.email}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Mobile Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="mobile"
                          className={`form-control ${errors.mobile ? 'is-invalid' : ''}`}
                          value={formData.mobile}
                          onChange={handleChange}
                          placeholder="10 digit mobile number"
                          maxLength="10"
                        />
                        {errors.mobile && (
                          <div className="invalid-feedback">{errors.mobile}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Alternative Mobile
                        </label>
                        <input
                          type="text"
                          name="alternativeMobile"
                          className={`form-control ${errors.alternativeMobile ? 'is-invalid' : ''}`}
                          value={formData.alternativeMobile}
                          onChange={handleChange}
                          placeholder="10 digit mobile number"
                          maxLength="10"
                        />
                        {errors.alternativeMobile && (
                          <div className="invalid-feedback">{errors.alternativeMobile}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Years of Experience
                        </label>
                        <input
                          type="number"
                          name="yearofExperience"
                          className={`form-control ${errors.yearofExperience ? 'is-invalid' : ''}`}
                          value={formData.yearofExperience}
                          onChange={handleChange}
                          placeholder="0.0"
                          min="0"
                          step="0.1"
                        />
                        {errors.yearofExperience && (
                          <div className="invalid-feedback">{errors.yearofExperience}</div>
                        )}
                      </div>

                      {/* Family Information */}
                      <div className="col-12 mt-4">
                        <h5 className="text-primary border-bottom pb-2 mb-3">Family Information</h5>
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          Father's Name
                        </label>
                        <input
                          type="text"
                          name="fatherName"
                          className={`form-control ${errors.fatherName ? 'is-invalid' : ''}`}
                          value={formData.fatherName}
                          onChange={handleChange}
                          placeholder="Father's full name"
                          maxLength="100"
                        />
                        {errors.fatherName && (
                          <div className="invalid-feedback">{errors.fatherName}</div>
                        )}
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          Mother's Name
                        </label>
                        <input
                          type="text"
                          name="motherName"
                          className={`form-control ${errors.motherName ? 'is-invalid' : ''}`}
                          value={formData.motherName}
                          onChange={handleChange}
                          placeholder="Mother's full name"
                          maxLength="100"
                        />
                        {errors.motherName && (
                          <div className="invalid-feedback">{errors.motherName}</div>
                        )}
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          Guardian's Name
                        </label>
                        <input
                          type="text"
                          name="guardianName"
                          className={`form-control ${errors.guardianName ? 'is-invalid' : ''}`}
                          value={formData.guardianName}
                          onChange={handleChange}
                          placeholder="Guardian's full name"
                          maxLength="100"
                        />
                        {errors.guardianName && (
                          <div className="invalid-feedback">{errors.guardianName}</div>
                        )}
                      </div>

                      {/* Social Information */}
                      <div className="col-12 mt-4">
                        <h5 className="text-primary border-bottom pb-2 mb-3">Social Information</h5>
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          Cast Category <span className="text-danger">*</span>
                        </label>
                        <select
                          name="castCategory"
                          className={`form-select ${errors.castCategory ? 'is-invalid' : ''}`}
                          value={formData.castCategory}
                          onChange={handleChange}
                        >
                          <option value="">--Select Category--</option>
                          {CAST_CATEGORIES.map((r) => (
                            <option key={r} value={r}>{r}</option>
                          ))}
                        </select>
                        {errors.castCategory && (
                          <div className="invalid-feedback">{errors.castCategory}</div>
                        )}
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          Religion <span className="text-danger">*</span>
                        </label>
                        <select
                          name="religion"
                          className={`form-select ${errors.religion ? 'is-invalid' : ''}`}
                          value={formData.religion}
                          onChange={handleChange}
                        >
                          <option value="">--Select Religion--</option>
                          {RELIGIONS.map((r) => (
                            <option key={r} value={r}>{r}</option>
                          ))}
                        </select>
                        {errors.religion && (
                          <div className="invalid-feedback">{errors.religion}</div>
                        )}
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          Pre-training Status <span className="text-danger">*</span>
                        </label>
                        <select
                          name="preTrainingStatus"
                          className={`form-select ${errors.preTrainingStatus ? 'is-invalid' : ''}`}
                          value={formData.preTrainingStatus}
                          onChange={handleChange}
                        >
                          <option value="">--Select Status--</option>
                          {PRETRAINING_STATUS.map((r) => (
                            <option key={r} value={r}>{r}</option>
                          ))}
                        </select>
                        {errors.preTrainingStatus && (
                          <div className="invalid-feedback">{errors.preTrainingStatus}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Disability <span className="text-danger">*</span>
                        </label>
                        <select
                          name="disability"
                          className={`form-select ${errors.disability ? 'is-invalid' : ''}`}
                          value={formData.disability}
                          onChange={handleChange}
                        >
                          <option value="">--Select Status--</option>
                          {DISABILITY_STATUS.map((r) => (
                            <option key={r} value={r}>{r}</option>
                          ))}
                        </select>
                        {errors.disability && (
                          <div className="invalid-feedback">{errors.disability}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Education <span className="text-danger">*</span>
                        </label>
                        <select
                          name="education"
                          className={`form-select ${errors.education ? 'is-invalid' : ''}`}
                          value={formData.education}
                          onChange={handleChange}
                        >
                          <option value="">--Select Education--</option>
                          {EDUCATION_LEVELS.map((r) => (
                            <option key={r} value={r}>{r}</option>
                          ))}
                        </select>
                        {errors.education && (
                          <div className="invalid-feedback">{errors.education}</div>
                        )}
                      </div>

                      {/* Address Information */}
                      <div className="col-12 mt-4">
                        <h5 className="text-primary border-bottom pb-2 mb-3">Address Information</h5>
                      </div>

                      <div className="col-12">
                        <label className="form-label">
                          Address <span className="text-danger">*</span>
                        </label>
                        <textarea
                          name="address"
                          className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                          value={formData.address}
                          onChange={handleChange}
                          rows="3"
                          placeholder="Enter complete address"
                          maxLength="255"
                        />
                        {errors.address && (
                          <div className="invalid-feedback">{errors.address}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          State <span className="text-danger">*</span>
                        </label>
                        <select
                          name="state"
                          className={`form-control ${errors.state ? 'is-invalid' : ''}`}
                          value={formData.state}
                          onChange={handleChange}
                        >
                          <option value="">--Select State--</option>
                          {Array.isArray(STATE) &&
                            STATE.map((r) => (
                              <option key={r} value={r}>
                                {r}
                              </option>
                            ))}
                        </select>
                        {errors.state && (
                          <div className="invalid-feedback">{errors.state}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Pincode <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="pinCode"
                          className={`form-control ${errors.pinCode ? 'is-invalid' : ''}`}
                          value={formData.pinCode}
                          onChange={handleChange}
                          placeholder="6 digit pincode"
                          maxLength="6"
                        />
                        {errors.pinCode && (
                          <div className="invalid-feedback">{errors.pinCode}</div>
                        )}
                      </div>

                      {/* Banking Information */}
                      <div className="col-12 mt-4">
                        <h5 className="text-primary border-bottom pb-2 mb-3">Banking Information</h5>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Bank Account Number
                        </label>
                        <input
                          type="text"
                          name="bankAccountNumber"
                          className={`form-control ${errors.bankAccountNumber ? 'is-invalid' : ''}`}
                          value={formData.bankAccountNumber}
                          onChange={handleChange}
                          placeholder="Bank account number"
                        />
                        {errors.bankAccountNumber && (
                          <div className="invalid-feedback">{errors.bankAccountNumber}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Bank Account Name
                        </label>
                        <input
                          type="text"
                          name="bankAccountName"
                          className={`form-control ${errors.bankAccountName ? 'is-invalid' : ''}`}
                          value={formData.bankAccountName}
                          onChange={handleChange}
                          placeholder="Account holder name"
                        />
                        {errors.bankAccountName && (
                          <div className="invalid-feedback">{errors.bankAccountName}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Bank Name
                        </label>
                        <input
                          type="text"
                          name="bankName"
                          className={`form-control ${errors.bankName ? 'is-invalid' : ''}`}
                          value={formData.bankName}
                          onChange={handleChange}
                          placeholder="Bank name"
                        />
                        {errors.bankName && (
                          <div className="invalid-feedback">{errors.bankName}</div>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          IFSC Code
                        </label>
                        <input
                          type="text"
                          name="ifsc"
                          className={`form-control ${errors.ifsc ? 'is-invalid' : ''}`}
                          value={formData.ifsc}
                          onChange={handleChange}
                          placeholder="IFSC code"
                        />
                        {errors.ifsc && (
                          <div className="invalid-feedback">{errors.ifsc}</div>
                        )}
                      </div>

                      {/* Project Information */}
                      <div className="col-12 mt-4">
                        <h5 className="text-primary border-bottom pb-2 mb-3">Project Information</h5>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Job Role <span className="text-danger">*</span>
                        </label>
                        <select
                          name="jobrole"
                          className={`form-select ${errors.jobrole ? 'is-invalid' : ''}`}
                          value={formData.projectTrans[0].jobrole}
                          onChange={handleJobRoleChange}
                        >
                          <option value="">--Select Job Role--</option>
                          {jobRoles.map((role) => (
                            <option key={role.id || role} value={role.name || role}>
                              {role.name || role}
                            </option>
                          ))}
                        </select>
                        {errors.jobrole && (
                          <div className="invalid-feedback">{errors.jobrole}</div>
                        )}
                      </div>

                      <div className="col-10 mt-3">
                        <h5 className="text-primary border-bottom pb-2 mb-3">Documents Upload</h5>
                      </div>

                      <div className="row g-3">
                        {[
                          { key: "candidatePhoto", prefix: "CANDIDATE", label: "Candidate Photo", storedKey: "candidatePhoto" },
                          { key: "aadharFront", prefix: "AADHAR_FRONT", label: "Aadhaar Card (Front)", storedKey: "frontAadharPhoto", required: true },
                          { key: "aadharBack", prefix: "AADHAR_BACK", label: "Aadhaar Card (Back)", storedKey: "backAadharPhoto", required: true },
                          { key: "educationCert", prefix: "EDUCATION", label: "Education Certificate", storedKey: "educationPhoto" },
                          { key: "cancelledCheque", prefix: "CANCELLED_CHEQUE", label: "Cancelled Cheque", storedKey: "bankPhoto" },
                        ].map(({ key, label, storedKey, required }) => (
                          <div className="col-md-6" key={key}>
                            <label className="form-label fw-semibold">
                              {label} {required && <span className="text-danger">*</span>}
                            </label>

                            <div className="d-flex align-items-center gap-2">
                              <input
                                type="file"
                                accept="image/*"
                                className={`form-control ${errors[key] ? "is-invalid" : ""}`}
                                onChange={(e) => handleFileUploadInstant(e, storedKey, key.toUpperCase())
                                }
                              />
                            </div>

                            {/* 🔹 Show filename info */}
                            {/* {(formData[key] || formData[storedKey]) && (
                            <small className="text-muted d-block mt-1">
                              {formData[key]?.name || formData[storedKey]}
                            </small>
                          )} */}
                            {formData[storedKey] && (() => {
                              const fullName = formData[storedKey];
                              const shortName =
                                fullName.length > 25 ? fullName.slice(0, 22) + "..." : fullName;

                              return (
                                <small
                                  className="text-primary d-block mt-1 text-decoration-underline"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleServerDownload(formData[storedKey], formData[storedKey], fullName)}
                                >
                                  {shortName}
                                </small>
                              );
                            })()}


                            {errors[key] && (
                              <div className="invalid-feedback">{errors[key]}</div>
                            )}
                          </div>
                        ))}

                        {/* Caste certificate (conditional) */}
                        {formData.castCategory && formData.castCategory !== "General" && (
                          <div className="col-md-6">
                            <label className="form-label fw-semibold">
                              Caste Certificate <span className="text-danger">*</span>
                            </label>
                            <div className="d-flex align-items-center gap-2">
                              <input
                                type="file"
                                accept="image/*,.pdf"
                                className={`form-control ${errors.castCert ? "is-invalid" : ""}`}
                                onChange={(e) => handleFileUploadInstant(e, "castPhoto", "CAST_CERT")
                                }
                              />
                              {/* {(formData.castCert || formData.castPhoto) && (
                                <button
                                  type="button"
                                  className="btn btn-outline-success btn-sm"
                                  onClick={() => {
                                    if (formData.castCert) handleServerDownload(formData.castPhoto, formData.castPhoto)
                                    else window.open(`${process.env.REACT_APP_API_URL}/formData/${formData.castPhoto}`, "_blank");
                                  }}
                                  title="Download file"
                                >
                                  <i className="fa fa-download"></i>
                                </button>
                              )} */}
                            </div>
                            {/* {(formData.castCert || formData.castPhoto) && (
                            <small className="text-muted d-block mt-1">
                              {formData.castCert?.name || formData.castPhoto}
                            </small>
                          )}
                          {errors.castCert && (
                            <div className="invalid-feedback">{errors.castCert}</div>
                          )}
                        </div>
                      )} */}
                            {(formData.castCert || formData.castPhoto) && (() => {
                              const fullName = formData.castCert?.name || formData.castPhoto;
                              const shortName = fullName.length > 25 ? `${fullName.substring(0, 22)}...` : fullName;

                              return (
                                <small
                                  className="text-primary d-block mt-1 text-decoration-underline"
                                  style={{ cursor: "pointer" }}
                                  title={fullName}
                                  onClick={() => {
                                    if (formData.castCert) {
                                      handleLocalDownload(formData.castCert);
                                    } else {
                                      handleServerDownload(formData.castPhoto, formData.castPhoto);
                                    }
                                  }}
                                >
                                  {shortName} (Click to download)
                                </small>
                              );
                            })()}

                            {errors.castCert && (
                              <div className="invalid-feedback">{errors.castCert}</div>
                            )}
                          </div>
                        )}
                      </div>

                      {/* <div className="col-md-6">
                        <label className="form-label">
                          Submitted By
                        </label>
                        <input
                          type="text"
                          name="submittedBy"
                          className={`form-control ${errors.submittedBy ? 'is-invalid' : ''}`}
                          value={formData.submittedBy}
                          onChange={handleChange}
                          placeholder="Name of person submitting"
                          maxLength="200"
                        />
                        {errors.submittedBy && (
                          <div className="invalid-feedback">{errors.submittedBy}</div>
                        )}
                      </div> */}

                      <div className="col-12">
                        <div className="d-flex justify-content-end gap-2">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => navigate(`/manageCandidates/${projectId}`)}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success"
                            disabled={loading}
                          >
                            {/* {loading ? "Adding..." : "Add Candidate"} */}
                            {loading
                              ? (isEditMode ? "Updating..." : "Adding...")
                              : (isEditMode ? "Update Candidate" : "Add Candidate")}

                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}